import script from "./TestDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./TestDashboard.vue?vue&type=script&setup=true&lang=js"

import "./TestDashboard.vue?vue&type=style&index=0&id=6bed9e36&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bed9e36"]])

export default __exports__